const proPlansDescriptions = {
  long: "Get full access to advanced link analytics, editing and management.",
  short: "to take your brand to the next level.",
};

const bulkPlansDescriptions = {
  long: "Generate, edit and manage your links in bulk.",
  short: "for massive amounts of link shortening",
};

const enterprisePlansDescriptions = {
  long: "A tailor-made plan for enterprises that need more than what our regular plans offer.",
  short: "for custom-made solutions.",
};

const qaPlansDescriptions = {
  long: "A lower limit plans with full access to advanced link analytics, editing and management meant for testing.",
  short: "for custom testing.",
};

const bfcmPlansDescriptions = {
  long: "The plan customized for you on Black Friday, that includes link management, analytics, and using your own domains.",
};

export default {
  groups: {
    pro: proPlansDescriptions,
    bulk: bulkPlansDescriptions,
    enterprise: enterprisePlansDescriptions,
    qa: qaPlansDescriptions,
  },

  default: {
    title: "Custom",
    name: "Custom",
    description: {
      long: "With a custom subscription, you have the freedom to choose the features and services that matter most to you, and only pay for what you need.",
      short: "tailored to your unique needs and preferences.",
    },
  },
  personal: {
    title: "Personal",
    description: {
      long: "Perfect for personal users that need access to detailed analytics and our link management dashboard.",
      short: "for users that need access detailed analytics and dashboard.",
    },
  },
  free: {
    title: "Free",
    name: "Free",
    description: {
      long: "Free basic ad-supported shortening for individual users. Customize your links and keep track of your link history.",
      short: "basic ad-supported shortening for individual users.",
    },
  },

  blackfriday2021: { title: "Black Friday", description: bfcmPlansDescriptions },
  blackfriday2022: { title: "Black Friday", description: bfcmPlansDescriptions },
  blackfriday2023: { title: "Black Friday", description: bfcmPlansDescriptions },
  blackfriday2024: { title: "Black Friday", description: bfcmPlansDescriptions },

  pro:            { title: "Pro Legacy",      description: proPlansDescriptions },
  pro5k:          { title: "Pro 5K Legacy",   description: proPlansDescriptions },
  pro50k:         { title: "Pro 50K Legacy",  description: proPlansDescriptions },
  "pro60-2025":   { title: "Pro 60",   description: proPlansDescriptions },
  "pro125-2025":  { title: "Pro 125",  description: proPlansDescriptions },
  "pro250-2025":  { title: "Pro 250",  description: proPlansDescriptions },
  "pro500-2025":  { title: "Pro 500",  description: proPlansDescriptions },
  "pro1k-2025":   { title: "Pro 1K",   description: proPlansDescriptions },
  "pro2k-2025":   { title: "Pro 2K",   description: proPlansDescriptions },
  "pro2500-2025": { title: "Pro 2.5K", description: proPlansDescriptions },
  "pro3k-2025":   { title: "Pro 3K",   description: proPlansDescriptions },
  "pro4k-2025":   { title: "Pro 4K",   description: proPlansDescriptions },
  "pro5k-2025":   { title: "Pro 5K",   description: proPlansDescriptions },
  "pro10k-2025":  { title: "Pro 10K",  description: proPlansDescriptions },

  bulk:            { title: "Bulk Legacy",      description: bulkPlansDescriptions },
  bulk100k:        { title: "Bulk 100K Legacy", description: bulkPlansDescriptions },
  bulk250k:        { title: "Bulk 250K Legacy", description: bulkPlansDescriptions },
  bulk750k:        { title: "Bulk 750K Legacy", description: bulkPlansDescriptions },
  bulk1500k:       { title: "Bulk 1.5M Legacy", description: bulkPlansDescriptions },
  bulk3M:          { title: "Bulk 3M Legacy",   description: bulkPlansDescriptions },
  bulk5M:          { title: "Bulk 5M Legacy",   description: bulkPlansDescriptions },
  "bulk50k-2025":  { title: "Bulk 50K",  description: bulkPlansDescriptions },
  "bulk100k-2025": { title: "Bulk 100K", description: bulkPlansDescriptions },
  "bulk250k-2025": { title: "Bulk 250K", description: bulkPlansDescriptions },
  "bulk500k-2025": { title: "Bulk 500K", description: bulkPlansDescriptions },
  "bulk1M-2025":   { title: "Bulk 1M",   description: bulkPlansDescriptions },
  "bulk2M-2025":   { title: "Bulk 2M",   description: bulkPlansDescriptions },
  "bulk3M-2025":   { title: "Bulk 3M",   description: bulkPlansDescriptions },
  "bulk4M-2025":   { title: "Bulk 4M",   description: bulkPlansDescriptions },
  "bulk5M-2025":   { title: "Bulk 5M",   description: bulkPlansDescriptions },

  "enterprise-free":  { title: "Enterprise",       description: enterprisePlansDescriptions },
  "enterprise-trial": { title: "Enterprise Trial", description: enterprisePlansDescriptions },
  enterprise:         { title: "Enterprise",       description: enterprisePlansDescriptions },
  enterprise8M:       { title: "Enterprise 8M",    description: enterprisePlansDescriptions },
  enterprise15M:      { title: "Enterprise 15M",   description: enterprisePlansDescriptions },

  qa1: { title: "QA1", description: qaPlansDescriptions },
  qa2: { title: "QA2", description: qaPlansDescriptions },
  qa3: { title: "QA3", description: qaPlansDescriptions },

  "domain-renewal-service": {
    title: "Domain Renewal Service",
    description: {
      long: "Required to enable purchased domains autorenewal functionality.",
      short: "for domain autorenewal processing.",
    },
  },
  "intermediary": {
    title: "Intermediary",
    description: {
      long: "Required for migrating users from stripe to paddle.",
      short: "for stripe to paddle migration.",
    },
  },
  "paddle-plan-upgrade": {
    title: "Subscription Plan Change",
    description: {
      short: "Subscription upgrade service.",
      long: "Subscription upgrade service.",
    },
  },
};
